// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import iView from 'iview';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import 'iview/dist/styles/iview.css';
import uploader from 'vue-simple-uploader';
import VueClipboard from 'vue-clipboard2';


Vue.use(uploader);
Vue.use(iView);
Vue.use(VueClipboard);
Vue.use(Viewer, {
  defaultOptions: {
   zIndex:9999,
  }
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js